<template>
    <div v-if="false"></div>
</template>

<script>
import TileLayer from 'ol/layer/Tile'
import Projection from 'ol/proj/Projection'
import XYZSource from 'ol/source/XYZ'

const rdProjection = new Projection({
    code: 'EPSG:28992',
    extent: [-285401.92, 22598.08, 595401.92, 903401.92],
})

const matrixIds = new Array(15)
for (var i = 0; i < 15; ++i) {
    matrixIds[i] = i
}

export default {
    name: 'TileLayer',
    inject: ['map'],
    created() {
        this.tileLayer = new TileLayer({
            name: this.name,
            source: new XYZSource({
                url: this.url,
                projection: rdProjection,
                attributions: ['Kaartgegevens Kadaster | Atlas'],
            }),
        })

        this.map.addLayer(this.tileLayer)
    },
    unmounted() {
        this.map.removeLayer(this.tileLayer)
    },
    props: {
        name: String,
        url: String,
    },
}
</script>

<style scoped></style>
